import React from "react";
import { SanityLandingPageImageContentBlock } from "../../model/landing-page";
import SpacedSection from "../SpacedSection/SpacedSection";
import ImageGradientBlock from "../ImageGradientBlock/ImageGradientBlock";
import LogoImageBlock from "../LogoImageBlock/LogoImageBlock";

interface LandingPageImageContentBlockProps {
  value: SanityLandingPageImageContentBlock;
}

const LandingPageImageContentBlock = ({
  value: { style, content, image, background }
}: LandingPageImageContentBlockProps) => {
  switch (style) {
    case "image-left":
    case "image-right":
      return (
        <SpacedSection>
          <ImageGradientBlock
            color={background}
            imageSide={style === "image-left" ? "left" : "right"}
            content={content}
            image={image}
            dir="ltr"
          />
        </SpacedSection>
      );
    case "logo":
      return (
        <SpacedSection>
          <LogoImageBlock content={content} image={image} dir="ltr" />
        </SpacedSection>
      );
    default:
      throw new Error(`Unknown ${style}`);
  }
};

export default LandingPageImageContentBlock;
